import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  minHeight: theme.spacing(50),
  position: 'relative',

  '& .MSLoadingDotsInnerContainer': {
    position: 'absolute',
    zIndex: 10,
    backgroundColor: theme.palette.common.grey,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    left: '50%',
    bottom: theme.spacing(10),
    transform: 'translateX(-50%)',
    width:theme.spacing(10),
    height: theme.spacing(5),
    borderRadius: theme.spacing(1),
    boxShadow: '0px 12px 20px 0px rgba(0,0,0,0.75)',
  },
  '& .MSCloseBtn': {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 10,
    backgroundColor: theme.palette.common.grey,
    boxShadow: theme.shadows[1],
    color: theme.palette.common.white,
    padding: theme.spacing(1),
    borderRadius: '50%',
  },
  '& .MSSearchThisAreaBtn': {
    position: 'absolute',
    zIndex: 10,
    top: theme.spacing(15),
    left: '50%',
    transform: 'translateX(-50%)',
    borderRadius: 999,
    boxShadow: '0px 4px 4px -1px rgba(0,0,0,0.25)',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    padding: theme.spacing(1.5, 3, 1),
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 500,
    lineHeight: 1.5,
  },
}));

export default StyledBox;
